// ./src/contexts/PersonsContext/PersonsContext.tsx
//
// Thin context wrapper around the usePersons hook. All derived data lives in the
// hook itself. See MembershipsContext for the pattern.

import React, { createContext, useContext } from "react";

import { usePersons, UsePersonsOptions, UsePersonsReturn } from "@/hooks/usePersons";

const PersonsContext = createContext<UsePersonsReturn | null>(null);

export interface PersonsProviderProps extends UsePersonsOptions {
  children: React.ReactNode;
}

export const PersonsProvider: React.FC<PersonsProviderProps> = ({ children, ...options }) => {
  const value = usePersons(options);

  return <PersonsContext.Provider value={value}>{children}</PersonsContext.Provider>;
};

export const usePersonsContext = (): UsePersonsReturn => {
  const context = useContext(PersonsContext);

  if (!context) {
    throw new Error(
      "usePersonsContext must be used within a <PersonsProvider>. " +
        "Wrap your component tree with <PersonsProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalPersonsContext = (): UsePersonsReturn | null => {
  return useContext(PersonsContext);
};
